import { formatBytes, formatMs, formatNumber } from '../charts';

// Axis and readout formatters per contract unit. The axis drops precision the
// readout keeps: "34%" on a tick, "34.2%" in the tooltip.
// A request rate. Rounding to a whole number read a quiet service as dead: three calls
// in ten minutes is 0.3/min, which formatNumber drew as "0".
export function rate(v) {
  const n = Number(v) || 0;
  if (n === 0) return '0';
  if (n < 0.1) return '<0.1';
  if (n < 10) return n.toFixed(1).replace(/\.0$/, '');
  return formatNumber(n);
}

export const UNIT_FORMAT = {
  percent: { axis: v => `${Math.round(v)}%`, value: v => `${Number(v).toFixed(1)}%` },
  bytes_per_s: { axis: v => `${formatBytes(v, 0)}/s`, value: v => `${formatBytes(v)}/s` },
  bytes: { axis: v => formatBytes(v, 0), value: v => formatBytes(v) },
  per_min: { axis: rate, value: v => `${rate(v)}/min` },
  count: { axis: v => formatNumber(Math.round(v)), value: v => formatNumber(Math.round(v)) },
  ms: { axis: formatMs, value: formatMs },
  acu: { axis: v => (v < 10 ? Number(v).toFixed(1) : String(Math.round(v))), value: v => `${Number(v).toFixed(1)} ACU` },
};

export const fmt = (unit) => UNIT_FORMAT[unit] || UNIT_FORMAT.count;

export const vcpu = (units) => `${(units / 1024).toFixed(units % 1024 ? 2 : 0)} vCPU`;
export const gib = (mib) => (mib >= 1024 ? `${(mib / 1024).toFixed(mib % 1024 ? 1 : 0)} GiB` : `${mib} MiB`);

export function clock(ms) {
  if (!ms) return '—';
  const d = new Date(ms);
  return d.toLocaleString(undefined, {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

export function duration(seconds) {
  const s = Math.max(0, Math.round(seconds));
  if (s < 3600) return `${Math.round(s / 60)} min`;
  if (s < 86400) return `${Math.round(s / 3600)} h`;
  return `${Math.round(s / 86400)} d`;
}
